<template>
  <div>
    <vxe-grid
      ref="grid"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :loading="loading"
      :data="tableData"
      :columns="tableColumns"
      :height="600"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <div class="side-frame-danger group-title">
          <span>
            {{ $l("table_label_Material_plan_details" || "物料计划明细") }}
          </span>
        </div>
      </template>

      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:isSpecifyStatus="{ row }">
        <el-tag
          size="mini"
          :type="
            row.isSpecify === 'N' || row.isSpecify === 'Y' ? 'success' : 'light'
          "
        >
          {{ row.v_isSpecify }}
        </el-tag>
      </template>

      <template v-slot:expandContent="{ row }">
        <div class="m-2">
          <page-table
            :planCode="row.mrpMaterialPlanCode"
            :detailCode="row.mrpMaterialPlanDetailCode"
          />
        </div>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l("INDEX.table_label_no_data") || "暂无数据！" }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from "@/mixins/table-auto-height"
import tableColumns from "./table-columns"
import PageTable from "../table/components/detail-table"
export default {
  mixins: [TableAutoHeight],
  components: { PageTable },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: "toolbar_form",
        },
        refresh: {
          query: () => this.$emit("reload"),
        },
        zoom: true,
      },
      tableColumns: tableColumns(this),
      tableHeight: 600,
    }
  }
}
</script>
